export interface IProduktgruppSelectItem {
    id: number;
    namn: string;
    handelssortimentsgruppId: number;
    kategori: string;
}

export interface ITradslagSelectItem {
    id: number;
    kod: string;
    namn: string;
}

export interface ISortimentSelectItem {
    id: number;
    kod: string;
    namn: string;
    aktiv: boolean;
}

export interface IProduktspecifikationItems {
    id: number;
    giltigFrom: string;
    giltigTom: string;
}

export interface ISearchViol3ProduktModel {
    identitet: string;
    namn: string;
}

export enum FormMode { New, Edit, Copy, NotSet }

export enum FormModeName {

    New = "ny",

    Copy = "kopia"
}

export enum TabName {
    basdata = "basdata",
    fordelningsmatris = "fordelningsmatris",
    uppfoljning = "uppfoljning",
    produktinstruktioner = "produktinstruktioner"
}

export enum HandelssortimentsgruppKategori {
    sagtimmer = "Sågtimmer",
    massaved = "Massaved",
    energi = "Energi",
    ovrigt = "Övrigt"
}
